import { FC, useCallback, useEffect, useMemo, useState } from 'react'
import { checkSession } from '../../../api/ChatHelper'
import useUser from '../../../hooks/User'
import { useChatStore } from '../../../stores/ChatStore'
import { ToC } from '../../../components/Chat/ToC'
import { PageNoPermisson } from '../general/PageNoPermission'
import { useSettingsStore } from '../../../stores/SettingsStore'
import useAccessToken from '../../../hooks/AccessToken'
import { ChatSidebar } from '../../../components/Chat/ChatSidebar'
import { ChatWindow } from '../../../components/Chat/ChatWindow'
import moment from 'moment';
import { Socket, io } from 'socket.io-client';
import { Message } from '../../../interfaces/Chat/Message'
import { Onboarding } from '../../../components/Chat/Onboarding/Onboarding'
import Swal from 'sweetalert2'
import axios from 'axios'
import useSWR from 'swr'
import { MerchantLeads, RecentChatHistory } from '../../../interfaces/Chat/RecentChatHistory'
import { clearDB } from '../../../db'
import { ChatAside } from '../../../components/Chat/ChatAside'
import { ChatSetting } from '../../../components/Chat/Settings/ChatSetting'
import { ChatLabelSetting } from '../../../components/Chat/Settings/ChatLabelSetting'
import { ChatDetailLabelSetting } from '../../../components/Chat/Settings/ChatDetailLabelSetting'
import { ChatQuickReplySetting } from '../../../components/Chat/Settings/ChatQuickReplySetting'
import { SettingMultiMeetings, SettingMultiPipelines } from '../../../interfaces/Settings'
import { usePipelineStore } from '../../../stores/PipelineStore'
import { useUserStore } from '../../../stores/UserStore'
import { useCustomeStore } from '../../../stores/CustomeStore'
import { useDispatch } from 'react-redux'
import * as auth from '../../../app/modules/auth/redux/AuthRedux'
import ModalForwardChat from '../../../components/Chat/Modal/ForwardChat/ModalForwardChat'
import { USER_MANAGER_HAPPY_PLAY } from '../../../constant/General'
import useShowCompanyById from '../../../hooks/useShowCompanyById'
import { useTokenCustomCompany } from '../../../stores/useTokenCustomCompany'
import { getChatMessagesData, getChatRoomsData, getInitSyncData, getTotalChatData } from '../../../api/ChatCRUD'
import { calculateTotalChats, delay, isMerchantOnly, sortChatRooms } from '../../../functions/chat'
import SelectUser from '../../../components/Chat/Onboarding/SelectUser'
import { ListChatPhone } from '../../../interfaces/Chat/ListChatPhone'
import { useMeetingStore } from '../../../stores/MeetingsStore'
import useDynamicTab from '../../../hooks/useDynamicTab'
import { toAbsoluteUrl } from '../../../_metronic/helpers'
import { ChatInititate } from '../../../components/Chat/ChatInitiate'
import { ContactChatProps } from '../../../interfaces/Chat/ContactChat'
import { getUserByToken } from '../../modules/auth/redux/AuthCRUD'
import { getSettingAll } from '../../../api/SettingCRUD'
import { ChatMessage, ListChatRoom } from '../../../interfaces/Chat/Chat'

const Chat: FC = () => {
    const API_URL = process.env.REACT_APP_API_URL
    const token = useAccessToken()
    const {
        setMode, agreedTNC, setSelectedChatPhone, selectedChatPhone,
        socket, setLastSynced, setListChatPhone, setLoadingListChatPhone,
        setPersistedMessages, isFirstSyncing, setListChatRooms, setListChatMessages, setIsSyncing,
        connected, lastSynced, setRecentChatIsSyncing, tokenChat, setSocket,
        setMessagesIsSyncing, menuActive, setChatLabels, setChatContacts, phoneNumber, setQuickReplies,
        isOpenForwardChat, setIsOpenForwardChat
    } = useChatStore()
    const { settings, setSettings } = useSettingsStore()
    const { setSimplePipelines, setPipelineLoading, setSelectMultiPipeline, setMultiPipelines } = usePipelineStore()
    const { setSimpleMeetings, setSelectMultiMeeting, setMultiMeetings } = useMeetingStore()
    const { setUsers } = useUserStore()

    const [isMobile, setIsMobile] = useState<boolean>(false);
    const user = useUser()
    const { companyId } = useCustomeStore()
    const { tokenCustomCompany, numberCustomCompany } = useTokenCustomCompany()
    const [isTabActive, setIsTabActive] = useState(true)
    const dispatch = useDispatch()
    const { company } = useShowCompanyById(user.data.company_id)
    let totalChatMessage = 0

    const fetcher = (url: string) => axios.get(url, {
        headers: {
            'X-Auth-token': token
        }
    }).then(res => res.data.data)

    const { data: version = [], error: versionError, isLoading: versionLoading, isValidating: versionValidating } = useSWR(`${API_URL}version`, fetcher)
    const { data: labels = [], error: labelsError, isLoading: labelsIsLoading } = useSWR(`${API_URL}/chat/labels`, fetcher)
    const { data: quickRepliesData = [], error: quickRepliesError, isLoading: quickRepliesIsLoading } = useSWR(`${API_URL}/chat/quick-replies`, fetcher)
    const { data: leadTemplate = [], error: leadTemplateError, isLoading: leadTemplateLoading } = useSWR(`${API_URL}lead-templates`, fetcher)
    const { data: meetingTemplate = [], error: meetingTemplateError, isLoading: meetingTemplateLoading } = useSWR(`${API_URL}meeting-templates`, fetcher)
    const { data: userData = [], error: usersError, isLoading: usersLoading } = useSWR(`${API_URL}simple-users`, fetcher)
    const { data: leads = [], error: leadsError, isLoading: leadsLoading } = useSWR(`${API_URL}simple-leads`, fetcher)
    const { data: simpleMeetingsData = [], error: simpleMeetingsError, isLoading: simpleMeetingsLoading } = useSWR(`${API_URL}simple-meetings`, fetcher)
    const { data: contacts = [], error: contactsError, isLoading: contactsLoading } = useSWR(tokenChat ? `${API_URL}chat/contacts/${user.data.chat_phone}` : null, fetcher, { revalidateOnFocus: false, revalidateOnReconnect: false })

    const getInitSync = async (currentLimit: number, dataRoom: ChatMessage | null, until: string, since: string, phone: string, color: string, isFirst: boolean, valTokenChat: string) => {
        setIsSyncing(() => true)

        try {
            const response = await getInitSyncData(currentLimit, dataRoom?.phone!, until, since, phone, valTokenChat, token);
            if (response.data.success) {
                const { listChatRooms, listChatMessages, phoneNumber, setMessages } = useChatStore.getState();
                let tempChatRooms = { ...listChatRooms };
                let tempChatMessages = { ...listChatMessages };
                let dataInit = response.data.data;

                dataInit.rooms.forEach((chat: any) => {
                    if (isMerchantOnly(settings, chat, user) || !settings.chat_show_pic_only) {
                        let key = `${chat.roomPhone}-${chat.as}`;

                        let tempChat = {
                            ...chat.chats[0] || null,
                            phone: chat.roomPhone,
                            as: chat.as,
                            action: {
                                isEditing: false
                            }
                        }

                        if (!tempChatRooms[key]) {
                            tempChatRooms[key] = {
                                as: chat.as,
                                roomPhone: chat.roomPhone,
                                roomName: chat.roomName ? chat.roomName : chat.roomPhone,
                                isMerchantOnly: chat.isMerchantOnly,
                                chat: tempChat,
                                labels: [],
                                merchants: [],
                                pipelines: [],
                                color: color,
                                connected: true,
                                selected: false
                            }
                        } else {
                            if (isFirst) {
                                tempChatRooms[key] = {
                                    ...tempChatRooms[key],
                                    roomName: chat.roomName
                                }
                            } else if (!isFirst && !dataRoom) {
                                tempChatRooms[key] = {
                                    ...tempChatRooms[key],
                                    as: chat.as,
                                    roomPhone: chat.roomPhone,
                                    roomName: chat.roomName ? chat.roomName : chat.roomPhone,
                                    chat: tempChat,
                                }
                            } else if (!tempChatRooms[key].chat.id) {
                                tempChatRooms[key] = {
                                    ...tempChatRooms[key],
                                    chat: tempChat,
                                }
                            }
                        }

                        const sortChatMessage = chat.chats.map((temp: ChatMessage) => ({
                            ...temp,
                            phone: chat.roomPhone,
                            as: chat.as,
                            action: {
                                isEditing: false
                            }
                        })).sort((a: ChatMessage, b: ChatMessage) => new Date(a.receivedAt).getTime() - new Date(b.receivedAt).getTime());

                        if (!tempChatMessages[key]) {
                            tempChatMessages[key] = [...sortChatMessage]
                        } else {
                            if (isFirst) {
                                tempChatMessages[key] = [...sortChatMessage, ...tempChatMessages[key]]
                            } else {
                                if (dataRoom) tempChatMessages[key] = [...sortChatMessage, ...tempChatMessages[key]]
                                else tempChatMessages[key] = [...tempChatMessages[key], ...sortChatMessage]

                            }
                        }
                    }
                });

                // const worker = new Worker(new URL('./SortChatRoomWorker.ts', import.meta.url));
                // worker.postMessage({ data: tempChatRooms });
                // worker.onmessage = (event) => {
                //     const { data } = event.data;
                //     setListChatRooms(() => data);
                //     worker.terminate();
                // };

                // Update chat messages in room active
                if (phoneNumber) {
                    setMode('sync-room')
                    setMessages(() => tempChatMessages[`${phoneNumber}`] ?? [])
                }

                setListChatRooms(() => sortChatRooms(tempChatRooms));
                setListChatMessages(() => tempChatMessages);
                totalChatMessage += dataInit.total

                if (dataInit.newestDate) {
                    setSelectedChatPhone((prev) => prev.map((item) => (
                        item.phone === phone ? { ...item, newDateChat: item.newDateChat && isFirst ? item.newDateChat : dataInit.newestDate, oldDateChat: dataInit.oldestDate } : item
                    )));
                }

                if (dataInit.total >= currentLimit && totalChatMessage <= 100000) {
                    if (isFirst) getInitSync(currentLimit, dataRoom, dataInit.oldestDate, "", phone, color, isFirst, valTokenChat)
                    else {
                        if (dataRoom) getInitSync(currentLimit, dataRoom, dataInit.oldestDate, "", phone, color, isFirst, valTokenChat)
                        else getInitSync(currentLimit, dataRoom, "", dataInit.newestDate, phone, color, isFirst, valTokenChat)
                    }
                } else {
                    setSelectedChatPhone((prev) => prev.map((item) => (
                        item.phone === phone ? { ...item, lastSycned: moment().format('YYYY-MM-DD HH:mm:ss').toString() } : item
                    )));
                }
            }
        } catch (error: any) {
            setTimeout(() => getInitSync(currentLimit, dataRoom, until, since, phone, color, isFirst, valTokenChat), 2000)
        }
    };

    const handleIntSync = async (isFirst: boolean, dataRoom?: ChatMessage) => {
        const { selectedChatPhone, tokenChat } = useChatStore.getState();

        if (selectedChatPhone.length > 0 && tokenChat) {
            let limitInit = 5000
            for (const data of selectedChatPhone) {
                if (isFirst) {
                    await getInitSync(limitInit, null, "", "", data.phone, data.color, isFirst, tokenChat);
                } else {
                    if (dataRoom) {
                        await getInitSync(limitInit, dataRoom, dataRoom.receivedAt, "", data.phone, data.color, isFirst, tokenChat);
                    } else {
                        await getInitSync(limitInit, null, "", data.newDateChat ? data.newDateChat : "", data.phone, data.color, isFirst, tokenChat);
                    }
                }
    
                // Jeda 500ms antar permintaan
                await delay(500);
            }
        }
    }

    const getSetting = async () => {
        try {
            const response = await getSettingAll(token)
            if (response.data.success) {
                setSettings({
                    merchant_title: response.data.data.merchant_title ? response.data.data.merchant_title : "Klien",
                    merchant_custom_fields: response.data.data.merchant_custom_fields ? response.data.data.merchant_custom_fields : "",
                    pipeline_title: response.data.data.pipeline_title ? response.data.data.pipeline_title : "Pipeline",
                    pipeline_custom_fields: response.data.data.pipeline_custom_fields ? response.data.data.pipeline_custom_fields : "",
                    meeting_title: response.data.data.meeting_title ? response.data.data.meeting_title : "Meeting",
                    meeting_custom_fields: response.data.data.meeting_custom_fields ? response.data.data.meeting_custom_fields : "",
                    users_title: response.data.data.users_title ? response.data.data.users_title : 'Users',
                    users_custom_fields: response.data.data.users_custom_fields ? response.data.data.users_custom_fields : '',
                    termins_custom_fields: response.data.data.termins_custom_fields ? response.data.data.termins_custom_fields : '',
                    caps_lock_inputs: response.data.data.caps_lock_inputs === "true" ? true : false,
                    merchant_duplicate: response.data.data.merchant_duplicate === "true" ? true : false,
                    merchant_phone_can_be_changed: response.data.data.merchant_phone_can_be_changed === "true" ? true : false,
                    hide_top_three_sales: response.data.data.hide_top_three_sales === "true" ? true : false,
                    feature_check_number: response.data.data.feature_check_number === "true" ? true : false,
                    feature_pipeline: response.data.data.feature_pipeline === "true" ? true : false,
                    feature_meeting: response.data.data.feature_meeting === "true" ? true : false,
                    feature_chat: response.data.data.feature_chat === "true" ? true : false,
                    feature_chat_super_admin: response.data.data.feature_chat_super_admin === "true" ? true : false,
                    pipeline_abandoned_lock: response.data.data.pipeline_abandoned_lock === "true" ? true : false,
                    pipeline_date_min: response.data.data.pipeline_date_min ? response.data.data.pipeline_date_min : "",
                    template_pipeline: response.data.data.template_pipeline ? response.data.data.template_pipeline : "",
                    feature_meeting_mode: response.data.data.feature_meeting_mode ? response.data.data.feature_meeting_mode : "0",
                    meeting_auto_cancel: response.data.data.meeting_auto_cancel ? Number(response.data.data.meeting_auto_cancel) : -1,
                    feature_reimbursement: response.data.data.feature_reimbursement === "false" ? false : true,
                    update_log_hpp_progress: response.data.data.update_log_hpp_progress === "true" ? true : false,
                    chat_show_pic_only: response.data.data.chat_show_pic_only === "true" ? true : false,
                    radius_visit: response.data.data.radius_visit ? Number(response.data.data.radius_visit) : 1,
                    update_meeting: response.data.data.update_meeting === "true" ? true : false,
                    unlimited_add_lead_log: response.data.data.unlimited_add_lead_log === "true" ? true : false,
                    feature_activities: response.data.data.feature_activities ? response.data.data.feature_activities === 'true' ? true : false : true,
                    feature_attendance: response.data.data.feature_attendance ? response.data.data.feature_attendance === 'true' ? true : false : true,
                    feature_conference: response.data.data.feature_conference ? response.data.data.feature_conference === 'true' ? true : false : true,
                    feature_email: response.data.data.feature_email ? response.data.data.feature_email === 'true' ? true : false : true,
                    feature_label: response.data.data.feature_label ? response.data.data.feature_label === 'true' ? true : false : true,
                    feature_merchant: response.data.data.feature_merchant ? response.data.data.feature_merchant === 'true' ? true : false : true,
                    // feature_phone_validation: response.data.data.feature_phone_validation ? response.data.data.feature_phone_validation === 'true' ? true : false : true,
                    feature_product: response.data.data.feature_product ? response.data.data.feature_product === 'true' ? true : false : true,
                    feature_progress: response.data.data.feature_progress ? response.data.data.feature_progress === 'true' ? true : false : true,
                    feature_source: response.data.data.feature_source ? response.data.data.feature_source === 'true' ? true : false : true,
                    feature_target: response.data.data.feature_target ? response.data.data.feature_target === 'true' ? true : false : true,
                    feature_unit: response.data.data.feature_unit ? response.data.data.feature_unit === 'true' ? true : false : true,
                    feature_import_excel_pipeline: response.data.data.feature_import_excel_pipeline ? response.data.data.feature_import_excel_pipeline === 'true' ? true : false : false,
                    meeting_visit_disable_capture_camera: response.data.data.meeting_visit_disable_capture_camera ? response.data.data.meeting_visit_disable_capture_camera === 'true' ? true : false : false,
                    meeting_done_disable_capture_camera: response.data.data.meeting_done_disable_capture_camera ? response.data.data.meeting_done_disable_capture_camera === 'true' ? true : false : false,
                    feature_invoice: response.data.data.feature_invoice ? response.data.data.feature_invoice === 'true' ? true : false : false,
                })
            }
        } catch (error: any) {
            Swal.fire({
                icon: 'error',
                title: error.response.data.message,
                confirmButtonText: 'Ok',
            })
        }
    }

    useEffect(() => {
        getSetting()

        if (token && tokenChat) {
            const socket = io(`${API_URL}whatsapp-chat`, {
                reconnection: true,
                reconnectionDelayMax: 10000,
                auth: { CRMToken: token, token: tokenChat }
            });
            setSocket(() => socket)
        }
    }, [])

    useEffect(() => {
        if (!versionLoading) {
            if (!localStorage.getItem('version-crm')) {
                localStorage.setItem('version-crm', version)
            } else if (version !== localStorage.getItem("version-crm")) {
                localStorage.setItem('version-crm', version)
                clearDB()
                window.location.reload();
            }
        }
    }, [version])

    useEffect(() => {
        if (!leadTemplateLoading) {
            const result = leadTemplate.map((lead: SettingMultiPipelines) => ({
                ...lead,
                label: lead.name,
                value: lead.id,
            }));

            let dataLocal = localStorage.getItem("selectMultiPipeline")
            if (dataLocal) setSelectMultiPipeline(JSON.parse(dataLocal))
            else setSelectMultiPipeline(result[0])
            setMultiPipelines(result);
        }
    }, [leadTemplate]);

    useEffect(() => {
        if (!meetingTemplateLoading) {
            const result = meetingTemplate.map((lead: SettingMultiMeetings) => ({
                ...lead,
                label: lead.name,
                value: lead.id,
            }));

            let dataLocal = localStorage.getItem("selectMultiMeeting")
            if (dataLocal) setSelectMultiMeeting(JSON.parse(dataLocal))
            else setSelectMultiMeeting(result[0])
            setMultiMeetings(result);
        }
    }, [meetingTemplate]);

    useEffect(() => {
        if (!leadsLoading) {
            setSimplePipelines(leads)
        }
    }, [leads]);

    useEffect(() => {
        if (!simpleMeetingsLoading) {
            setSimpleMeetings(simpleMeetingsData)
        }
    }, [simpleMeetingsData]);

    useEffect(() => {
        if (!usersLoading) {
            setUsers(userData)
        }
    }, [userData]);

    useEffect(() => {
        if (!labelsIsLoading) {
            setChatLabels(labels)
        }
    }, [labelsIsLoading])

    useEffect(() => {
        if (!quickRepliesIsLoading && quickRepliesData) {
            setQuickReplies(quickRepliesData)
        }
    }, [quickRepliesIsLoading])

    useEffect(() => {
        const { tokenChat } = useChatStore.getState();
        if (!contactsLoading && tokenChat && !contactsError) {
            let dataIncludeName: ContactChatProps[] = []
            let dataExcludeName: ContactChatProps[] = []

            contacts.filter((contact: any) => contact.id.includes('@s.whatsapp.net')).map((contact: any) => {
                if (contact.name || contact.notify || contact.verifiedName) {
                    dataIncludeName.push({
                        ...contact,
                        name: contact.notify || contact.name || contact.verifiedName,
                    })
                } else {
                    dataExcludeName.push({
                        ...contact,
                        name: contact.id.replace('@s.whatsapp.net', '')
                    })
                }
            })

            dataIncludeName.sort((a: any, b: any) => (a.name || "").localeCompare(b.name || ""));
            setChatContacts([...dataIncludeName, ...dataExcludeName]);
        }
    }, [contacts])

    useEffect(() => {
        socket.on('disconnect', () => {
            setTimeout(() => {
                socket.connect();
                const { lastSynced } = useChatStore.getState();
                if (lastSynced) handleIntSync(false)
            }, 100);
        })

        socket.on('sessionDisconnected', () => {
            clearDB()
            Swal.fire({
                title: 'Session Disconnected',
                icon: 'warning',
                allowOutsideClick: false,
            }).then((res) => {
                clearDB()
                window.location.reload()
            })
        })

        return () => {
            socket.off('sessionDisconnected')
        }
    }, [socket])

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 1200) {
                setIsMobile(true);
            } else {
                setIsMobile(false);
            }
        };

        // Initial check
        handleResize();

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    useEffect(() => {
        if (lastSynced) handleIntSync(false)
        else handleIntSync(true)
    }, [tokenChat])

    useEffect(() => {
        const hasLastSynced = selectedChatPhone.length > 0 && selectedChatPhone.every(item => item.lastSycned && item.lastSycned !== null);
        if (hasLastSynced) {
            setLastSynced(moment().format('YYYY-MM-DD HH:mm:ss').toString());
            setIsSyncing(() => false)
        }
    }, [selectedChatPhone])

    let style = { display: "flex" }
    if (menuActive === "chat") style = { display: "flex" }
    else style = { display: "none" }

    let menu = <></>
    if (menuActive === "settings") menu = <ChatSetting />
    else if (menuActive === "settings-label") menu = <ChatLabelSetting />
    else if (menuActive === "settings-detail-label") menu = <ChatDetailLabelSetting />
    else if (menuActive === "settings-quick-reply") menu = <ChatQuickReplySetting />
    else if (menuActive === "initiate-chat") menu = <ChatInititate />

    document.addEventListener('contextmenu', event => event.preventDefault());
    useDynamicTab({ title: `Wooblazz Chat`, icon: toAbsoluteUrl('/media/logos/logo-wooblazz-chat-square.png') });

    useEffect(() => {
        const channel = new BroadcastChannel('whatsapp_tab_channel');
        channel.postMessage('tab_opened');
        channel.onmessage = (event) => {
            if (event.data === 'tab_opened') {
                setIsTabActive(false);
                Swal.fire({
                    title: 'Wooblazz Chat sedang terbuka di jendela lain',
                    text: 'Klik "Gunakan di Sini" untuk menggunakan Wooblazz Chat di jendela ini.',
                    showCancelButton: true,
                    confirmButtonText: 'Gunakan di Sini',
                    cancelButtonText: 'Tutup',
                    confirmButtonColor: '#00a884',
                    cancelButtonColor: '#8696a0',
                }).then((result) => {
                    if (result.isConfirmed) {
                        channel.postMessage('take_control');
                        setIsTabActive(true);
                        window.location.reload();
                    } else {
                        window.close();
                    }
                });
            } else if (event.data === 'take_control') {
                setIsTabActive(false);
                window.close();
            }
        };

        return () => {
            channel.close();
        };
    }, []);

    return (
        <>
            {isTabActive ? (
                <>
                    {
                        !agreedTNC && <ToC />
                    }
                    {
                        !settings.feature_chat ?
                            <PageNoPermisson title='' />
                            :
                            agreedTNC &&
                            <>
                                {
                                    (!tokenChat || !connected) && <SelectUser />
                                    // : (listChatPhone?.length === 1 && !connected) && <Onboarding totalRecentChats={totalRecentChats} totalChats={totalChats} />
                                }
                                <div className={`row me-0 mt-2 ${(!connected) && 'd-none'}`}>
                                    <div className={`col-12 col-xl-4 d-${phoneNumber ? 'none' : 'flex'} d-lg-${phoneNumber ? 'none' : 'flex'} d-xl-flex`}>
                                        <ChatAside />
                                        <ChatSidebar style={style} handleIntSync={handleIntSync} />
                                        {menu}
                                    </div>
                                    <div className={`col-12 col-xl-8 d-${phoneNumber ? 'block' : 'none'} d-lg-${phoneNumber ? 'block' : 'none'} d-xl-block`}>
                                        <ChatWindow handleIntSync={handleIntSync} />
                                    </div>
                                </div>
                                <ModalForwardChat isOpen={isOpenForwardChat} onClose={() => setIsOpenForwardChat(false)} />
                            </>
                    }
                </>
            ) : null}
        </>
    )
}

export { Chat } 